module.exports = __webpack_public_path__ + "img/like.ebcfb3e6.png";